import { render, staticRenderFns } from "./NewWC.vue?vue&type=template&id=4e39be3c&scoped=true&"
import script from "./NewWC.vue?vue&type=script&lang=js&"
export * from "./NewWC.vue?vue&type=script&lang=js&"
import style0 from "./NewWC.vue?vue&type=style&index=0&id=4e39be3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e39be3c",
  null
  
)

export default component.exports